import React, { FC, useContext } from 'react';
import { ActiveTabContext } from '../Common/Tabs/TabProvider';
import { useSharedTab } from '../Common/Tabs/useSharedTab';
import { filterInvalidChildren } from '../Common/Tabs/filterInvalidChildren';
import { TabConfigArray } from '../Common/Tabs/sharedTypes';
import styles from './main.scss';

type TabPanelProps = {
    name: string; // name must be unique among TabPanels and correspond with Tab
    renderOnInactive?: boolean;
};

type TabPanelsProps = {
    children: TabConfigArray;
    renderOnInactive?: boolean;
};

const TabPanel: FC<TabPanelProps> = ({ name, renderOnInactive, children }) => {
    const { tab, panel } = useSharedTab(name, 'panel');
    const { activeTab } = useContext(ActiveTabContext) || {};
    const isActive = activeTab === name;

    return (
        <div
            className={styles.tabPanel}
            tabIndex={-1}
            hidden={!isActive || undefined}
            role="tabpanel"
            aria-labelledby={tab}
            id={panel || undefined}
        >
            {isActive || renderOnInactive ? children : null}
        </div>
    );
};

export const TabPanels: FC<TabPanelsProps> = ({ renderOnInactive, children }) => {
    // allow falsy in children, but remove them to allow for conditional rendering
    // in consumers.
    // e.g. children = [isAllowed ? <MyTabPanel> : null, <MyTabPanel />]
    const validChildren = children.filter(filterInvalidChildren);
    return (
        <>
            {validChildren.map(([name, component]) => (
                <TabPanel renderOnInactive={renderOnInactive} key={name} name={name}>
                    {component}
                </TabPanel>
            ))}
        </>
    );
};
